import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Checkbox, FormControl } from 'react-bootstrap'

const FormInput3 = ({ autoComplete, children, className, dataRef, id, isChecked, isDisabled, isReadOnly, isValid, onChange, placeholder, type, size, value, ...props }) => {
  switch (type) {
    case 'checkbox': {
      const handleChange = (e) => onChange(e.target.checked)
      return (
        <Checkbox
          checked={isChecked}
          bsSize={size}
          className={className}
          data-ref={dataRef}
          disabled={isDisabled}
          id={id}
          onChange={handleChange}
          readOnly={isReadOnly}
          value={value}
          {...props}
        >
          {children}
        </Checkbox>
      )
    }

    case 'select':
      return (
        <FormControl
          bsSize={size}
          className={className}
          componentClass={type}
          data-ref={dataRef}
          disabled={isDisabled}
          id={id}
          onChange={(e) => onChange(e.target.value)}
          readOnly={isReadOnly}
          value={value}
          {...props}
        >
          {children}
        </FormControl>
      )

    case 'textarea':
      return (
        <FormControl
          bsSize={size}
          className={className}
          componentClass={type}
          data-ref={dataRef}
          disabled={isDisabled}
          id={id}
          onChange={onChange}
          readOnly={isReadOnly}
          value={value}
          {...props}
        />
      )

    default:
      return (
        <FormControl
          autoComplete={autoComplete}
          bsSize={size}
          className={className}
          disabled={isDisabled}
          data-ref={dataRef}
          id={id}
          onChange={onChange}
          placeholder={placeholder}
          readOnly={isReadOnly}
          type={type}
          value={value}
          {...props}
        />
      )
  }
}

FormInput3.propTypes = {
  autoComplete: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  dataRef: PropTypes.string,
  id: PropTypes.string,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isValid: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg']),
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

FormInput3.defaultProps = {
  autoComplete: 'on',
  className: '',
  isDisabled: false,
  isReadOnly: false,
  isValid: true,
  type: 'text'
}

const isEqual = (prevProps, nextProps) => !nextProps.children &&
    prevProps.className === nextProps.className &&
    prevProps.isChecked === nextProps.isChecked &&
    prevProps.isDisabled === nextProps.isDisabled &&
    prevProps.isReadOnly === nextProps.isReadOnly &&
    prevProps.isValid === nextProps.isValid &&
    prevProps.placeholder === nextProps.placeholder &&
    prevProps.type === nextProps.type &&
    prevProps.value === nextProps.value

export default memo(FormInput3, isEqual)
